import React, {
  Suspense, lazy
} from 'react';
import styled from 'styled-components';
import NavigationBar from '../NavigationBar';

const HamburgerMenu = lazy(() => import('../HamburgerMenu'));
const ShopMenu = lazy(() => import('../ShopMenu'));

interface OwnProps {
  /** featured links (mostly categories) mobile menu */
  featuredLinksMobileMenu: Array<any>;
  /** navigation links of mobile menu */
  mobileNavigationLinks: Array<any>;
  /** additional content mobile menu */
  featuredMobileSpot: Record<any, any>;
  /** main cta buttons */
  ctaButtons: Array<any>;
  /** logo */
  logo: any;
  /** search shop menu on mobile */
  mobileShopMenu?: any;
  /** navivation links */
  navigationLinks: Array<any>;
  /** whether to display suggestions or not */
  showSearchSuggestions: boolean;
  /** search suggestions component */
  searchSuggestions: any;
}

const StyledNavBar = styled.header<Partial<OwnProps>>`
top: 0;
left: 0;
z-index: 999;
transition: background-color 0.1s ease-in 0s, box-shadow 0.15s ease-in 0s;
will-change: background-color, box-shadow;
position: sticky;
background-color: rgb(255, 255, 255);
box-shadow: rgb(0 0 0 / 5%) 0px 2px 4px 0px;
width: 100%;

.container__max {
  width: 100%;
  margin: 0px auto;
  max-width: 1440px;

  .flex__column {
    padding: 1rem 1.5rem;
    display: flex;
    flex-direction: column;
    -webkit-box-pack: start;
    -webkit-box-align: center;
    align-items: center;
    flex-flow: row wrap;
    justify-content: space-between;
    position: relative;

    @media (max-width: 992px) {
      padding: 0.75rem 1.5rem;
    }

    @media (max-width: 768px) {
      padding: 0.5rem 1rem;
    }
  }
}

  div.search__container {
    @media (max-width: 992px) {
      display: none;
    }
  }

  .logo__container {
    flex-basis: 16.6667%;
    max-width: 16.6667%;
    max-height: 34px;
    justify-content: flex-start;
    z-index: 1001;

    @media (max-width: 992px) {
      order: 2;
      margin: auto;
      flex-basis: 20%;
      max-width: 20%;
    }

    @media (max-width: 576px) {
      order: 2;
      margin: auto;
      flex-basis: 25%;
      max-width: 25%;
    }

    a {
      background-image: ${(props) => (props?.logo?.image?.image?.gatsbyImageData?.images?.fallback?.src
    ? `url(${props?.logo?.image?.image?.gatsbyImageData?.images?.fallback?.src})`
    : `url(https:${props?.logo?.image?.image?.file?.url})`)};
      display: block;
      max-height: 34px;
      min-height: 30px;
      background-repeat: no-repeat;
      z-index: 1000;
      background-position: left center;
      background-size: 130px;

      @media (max-width: 768px) {
        background-size: 100%;
        background-position: center;
      }
    }
  }
`;

const NavigationBarAndMenu = (props: OwnProps) => {
  const {
    featuredLinksMobileMenu, mobileNavigationLinks, featuredMobileSpot, ctaButtons,
    logo, navigationLinks, showSearchSuggestions, mobileShopMenu, searchSuggestions,
  } = props;
  const isSSR = typeof window === 'undefined';

  return (
    <>
      {!isSSR && (
        <Suspense fallback={<div />}>
          <HamburgerMenu
            featuredLinksMobileMenu={featuredLinksMobileMenu}
            mobileNavigationLinks={mobileNavigationLinks}
            featuredMobileSpot={featuredMobileSpot}
            ctaButtons={ctaButtons}
          />
        </Suspense>
      )}
      <StyledNavBar logo={logo}>
        <nav className="container__max">
          <div className="flex__column">
            <div className="logo__container">
              <a
                href={logo?.imageUrl?.url || logo?.url}
                data-component-type="image-link-text"
                className="trk-ga"
              >
                <span className="sr">{logo?.assistiveText}</span>
              </a>
            </div>
            {showSearchSuggestions && !isSSR
                && (
                  <Suspense fallback={<div className="search__container" />}>
                    <div className="search__container">
                      {searchSuggestions}
                    </div>
                  </Suspense>
                )}
            <NavigationBar
              navigationLinks={navigationLinks}
              ctaButtons={ctaButtons}
            />
          </div>
          {showSearchSuggestions && !isSSR && (
          <Suspense fallback={<div />}>
            <ShopMenu
              fields={mobileShopMenu}
              searchSuggestions={searchSuggestions}
            />
          </Suspense>
          )}
        </nav>
      </StyledNavBar>
    </>
  );
};

export default NavigationBarAndMenu;
